import AudioVisualizerCanvas from "./AudioVisualizerCanvas"

const drawVolumeBar = ( ctx, levels, width, height ) => {
    ctx.fillStyle = "grey"
    ctx.fillRect( 0, 0, width, height )

    ctx.fillStyle = "blue"
    ctx.fillRect( 0, 0, levels[0] * width, height )
}

const AudioVisualizerVolumeBar = ( { audioTrack, width = 100, height = 6 } ) => (
    <AudioVisualizerCanvas
        audioTrack={audioTrack}
        type="volumebar"
        draw={drawVolumeBar}
        width={width}
        height={height}
    />
)

export default AudioVisualizerVolumeBar
